export default __webpack_public_path__ + "static/media/faqs_background.80ab8722.jpg";